export default "__VITE_ASSET__BvmkqU_J__"